import { Card, Flex, Typography } from 'antd';
import { Outlet } from 'react-router-dom';

const APP_NAME = 'Учёт товаров';

export function AuthLayout() {
  return (
    <Flex align="center" justify="center" style={{ minHeight: '100vh', padding: 16 }}>
      <Card style={{ width: '100%', maxWidth: 400 }}>
        <Flex vertical gap={24}>
          <Typography.Title level={3} style={{ margin: 0, textAlign: 'center' }}>
            {APP_NAME}
          </Typography.Title>
          <Outlet />
        </Flex>
      </Card>
    </Flex>
  );
}
